import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import TableRow from "@mui/material/TableRow";
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

function InvoiceTableHeader({ withheldAmount }) {
  const { borderWidth } = borders;
  const { light } = colors;
  const borderBottom = `${borderWidth[1]} solid ${light.main}`;
  return (
    <SoftBox component="thead">
      <TableRow>
        <SoftBox
          component="th"
          width={{ xs: "40%" }}
          py={1.5}
          px={1}
          textAlign="left"
          borderBottom={borderBottom}
        >
          <SoftTypography variant="h6" color="text" fontWeight="medium" fontSize={"10pt"}>
            Περιγραφή
          </SoftTypography>
        </SoftBox>
        <SoftBox
          component="th"
          py={1.5}
          pl={3}
          pr={1}
          width={{ xs: "5%" }}
          textAlign="left"
          borderBottom={borderBottom}
        >
          <SoftTypography variant="h6" color="text" fontWeight="medium" fontSize={"10pt"}>
            Ποσ.
          </SoftTypography>
        </SoftBox>
        <SoftBox
          component="th"
          py={1.5}
          pl={3}
          pr={1}
          textAlign="left"
          width={{ xs: "5%" }}
          borderBottom={borderBottom}
        >
          <SoftTypography variant="h6" color="text" fontWeight="medium" fontSize={"10pt"}>
            Μ.Μ.
          </SoftTypography>
        </SoftBox>
        <SoftBox
          component="th"
          py={1.5}
          pl={3}
          pr={1}
          textAlign="left"
          width={{ xs: "10%" }}
          borderBottom={borderBottom}
        >
          <SoftTypography variant="h6" color="text" fontWeight="medium" fontSize={"10pt"}>
            Καθαρή Αξία
          </SoftTypography>
        </SoftBox>
        <SoftBox
          component="th"
          py={1.5}
          pl={3}
          pr={1}
          textAlign="left"
          width={{ xs: "10%" }}
          borderBottom={borderBottom}
        >
          <SoftTypography variant="h6" color="text" fontWeight="medium" fontSize={"10pt"}>
            Έκπτωση
          </SoftTypography>
        </SoftBox>
        <SoftBox
          component="th"
          py={1.5}
          pl={3}
          pr={1}
          textAlign="left"
          width={{ xs: "10%" }}
          borderBottom={borderBottom}
        >
          <SoftTypography variant="h6" color="text" fontWeight="medium" fontSize={"10pt"}>
            Κατ. Φ.Π.Α.
          </SoftTypography>
        </SoftBox>
        <SoftBox
          component="th"
          py={1.5}
          pl={3}
          pr={1}
          textAlign="left"
          width={{ xs: "10%" }}
          borderBottom={borderBottom}
        >
          <SoftTypography variant="h6" color="text" fontWeight="medium" fontSize={"10pt"}>
            Φ.Π.Α.
          </SoftTypography>
        </SoftBox>
        {withheldAmount > 0 ? (
          <SoftBox
            component="th"
            py={1.5}
            pl={3}
            pr={1}
            textAlign="left"
            width={{ xs: "10%" }}
            borderBottom={borderBottom}
          >
            <SoftTypography variant="h6" color="text" fontWeight="medium" fontSize={"10pt"}>
              Παρακράτηση
            </SoftTypography>
          </SoftBox>
        ) : (
          ""
        )}

        <SoftBox
          component="th"
          py={1.5}
          pl={3}
          pr={1}
          textAlign="left"
          width={{ xs: "10%" }}
          borderBottom={borderBottom}
        >
          <SoftTypography variant="h6" color="text" fontWeight="medium" fontSize={"10pt"}>
            Τελικό
          </SoftTypography>
        </SoftBox>
      </TableRow>
    </SoftBox>
  );
}

export default InvoiceTableHeader;
